import fetch from '../utils/fetch';

export const getPromotion = id =>
  fetch(`promotions/${id}`, null, { method: 'GET' });

export const getPerks = (accessToken, brand) =>
  fetch(`promotions/perks/?brand=${brand}`, accessToken, { method: 'GET' });

export const generatePerkCode = (perkId, accessToken, brand) =>
  fetch(`promotions/${perkId}/perk-code?brand=${brand}`, accessToken, {
    method: 'POST',
  });
